import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leftbutton-fill",
  "use": "icon-leftbutton-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-leftbutton-fill\"><path d=\"M512 149.333333c200.298667 0 362.666667 162.368 362.666667 362.666667s-162.368 362.666667-362.666667 362.666667S149.333333 712.298667 149.333333 512 311.701333 149.333333 512 149.333333z m42.666667 168.085334L360.085333 512 554.666667 706.581333 599.914667 661.333333l-149.333334-149.333333 149.333334-149.333333L554.666667 317.418667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol